import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import mergeWith from 'lodash/mergeWith';
import { getGridSettings } from '@/services/widgetTheme/utils';
import design from '@/config/design';
import templateEngine from '@/utils/templateEngine';
import { isDark } from '@/utils/colors';
import { selectEditingArea } from '@/components/Editor/hooks/useEditingAreas';
import { getClickPositionFromEvent } from '@/utils/dom';
import { arrayOverwriteStrategy, deleteUndefinedValues } from '@/utils/objects'; // Filter out collapsed group
// when all its' values are not truthy

export function filterCollapsedGroups(group, options, collectionOption) {
  if (options.collapsible || collectionOption !== null && collectionOption !== void 0 && collectionOption.collapsible) {
    return group.data.some(item => Boolean(item.value));
  }

  return true;
} // Calculate min/max of all datasets

export function getDataBoundaries(datasets) {
  let stacked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (stacked) {
    // Calculate min/max for stacked datasets
    // by summing up all values in each column
    const columnCount = datasets.reduce((acc, dataset) => {
      return Math.max(acc, dataset.data.length);
    }, 0);
    let min = 0;
    let max = 0;

    for (let i = 0; i < columnCount; i++) {
      // Sum up all values in the column
      const columnSum = datasets.reduce((sum, dataset) => sum + (dataset.data[i] || 0), 0);
      min = Math.min(min, columnSum);
      max = Math.max(max, columnSum);
    }

    return {
      min,
      max
    };
  }

  return datasets.reduce((acc, dataset) => {
    acc.min = Math.min(acc.min, ...dataset.data);
    acc.max = Math.max(acc.max, ...dataset.data);
    return acc;
  }, {
    min: Infinity,
    max: -Infinity
  });
} // Get data label color contrast to background color

export function getDataLabelColor(backgroundColor) {
  return isDark(backgroundColor) ? design.colors.white : design.colors.gray100;
}

function getDefaultDataLabelOptions() {
  return {
    display: false,
    color: design.colors.gray100,
    align: 'center',
    anchor: 'end',
    rotation: 0,
    clamp: true,
    template: '0'
  };
} // Get data label options for each data point
// based on series and collection options


export function getDataLabelOptions(params) {
  var _globalSeriesOptions$, _options$dataLabels, _collectionOption$dat, _globalSeriesOptions$2, _options$dataLabels2, _collectionOption$dat2, _globalSeriesOptions$3, _options$dataLabels3, _collectionOption$dat3, _globalSeriesOptions$4, _options$dataLabels4, _collectionOption$dat4, _globalSeriesOptions$5, _options$dataLabels5, _collectionOption$dat5, _globalSeriesOptions$6, _options$dataLabels6, _collectionOption$dat6;

  const {
    value,
    valueAxisTemplate,
    backgroundColor,
    options,
    globalSeriesOptions = {},
    defaultColor,
    defaultTemplate,
    collectionOption = {},
    defaults = {}
  } = params; // Merge default options

  const defaultOptions = _objectSpread(_objectSpread({}, getDefaultDataLabelOptions()), defaults); // Get contrast color for data labels


  const dataLabelColor = ((_globalSeriesOptions$ = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$ === void 0 ? void 0 : _globalSeriesOptions$.color) ?? ((_options$dataLabels = options.dataLabels) === null || _options$dataLabels === void 0 ? void 0 : _options$dataLabels.color) ?? (collectionOption === null || collectionOption === void 0 ? void 0 : (_collectionOption$dat = collectionOption.dataLabels) === null || _collectionOption$dat === void 0 ? void 0 : _collectionOption$dat.color) ?? defaultColor ?? getDataLabelColor(backgroundColor); // Data label options

  const displayDataLabels = ((_globalSeriesOptions$2 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$2 === void 0 ? void 0 : _globalSeriesOptions$2.display) ?? ((_options$dataLabels2 = options.dataLabels) === null || _options$dataLabels2 === void 0 ? void 0 : _options$dataLabels2.display) ?? ((_collectionOption$dat2 = collectionOption.dataLabels) === null || _collectionOption$dat2 === void 0 ? void 0 : _collectionOption$dat2.display) ?? defaultOptions.display;
  const alignment = ((_globalSeriesOptions$3 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$3 === void 0 ? void 0 : _globalSeriesOptions$3.alignment) ?? ((_options$dataLabels3 = options.dataLabels) === null || _options$dataLabels3 === void 0 ? void 0 : _options$dataLabels3.alignment) ?? ((_collectionOption$dat3 = collectionOption.dataLabels) === null || _collectionOption$dat3 === void 0 ? void 0 : _collectionOption$dat3.alignment) ?? defaultOptions.align;
  const anchoring = ((_globalSeriesOptions$4 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$4 === void 0 ? void 0 : _globalSeriesOptions$4.anchoring) ?? ((_options$dataLabels4 = options.dataLabels) === null || _options$dataLabels4 === void 0 ? void 0 : _options$dataLabels4.anchoring) ?? ((_collectionOption$dat4 = collectionOption.dataLabels) === null || _collectionOption$dat4 === void 0 ? void 0 : _collectionOption$dat4.anchoring) ?? defaultOptions.anchor;
  const rotation = ((_globalSeriesOptions$5 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$5 === void 0 ? void 0 : _globalSeriesOptions$5.rotation) ?? ((_options$dataLabels5 = options.dataLabels) === null || _options$dataLabels5 === void 0 ? void 0 : _options$dataLabels5.rotation) ?? ((_collectionOption$dat5 = collectionOption.dataLabels) === null || _collectionOption$dat5 === void 0 ? void 0 : _collectionOption$dat5.rotation) ?? defaultOptions.rotation; // Provide default template

  const dataLabelTemplate = ((_globalSeriesOptions$6 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$6 === void 0 ? void 0 : _globalSeriesOptions$6.template) ?? ((_options$dataLabels6 = options.dataLabels) === null || _options$dataLabels6 === void 0 ? void 0 : _options$dataLabels6.template) ?? ((_collectionOption$dat6 = collectionOption.dataLabels) === null || _collectionOption$dat6 === void 0 ? void 0 : _collectionOption$dat6.template) ?? valueAxisTemplate ?? options.template ?? defaultTemplate ?? '{{value}}';
  return {
    display: displayDataLabels,
    color: dataLabelColor,
    align: alignment,
    anchor: anchoring,
    rotation: rotation,
    template: templateEngine(dataLabelTemplate, typeof value === 'number' ? {
      value: value
    } : value)
  };
} // Extract data label property from context
// with default value

export function extractDataLabelProperty(context, property, defaultValue) {
  var _context$dataset$data;

  const dataLabel = (_context$dataset$data = context.dataset.datalabels) === null || _context$dataset$data === void 0 ? void 0 : _context$dataset$data[context.dataIndex];
  if (!dataLabel) return defaultValue;
  return dataLabel[property] ?? defaultValue;
} // Get the canvas element selector
// within the section

export function getSectionCanvasId(widgetId, sectionId) {
  return `${widgetId}-${sectionId}-canvas`;
} // Get the heading element selector
// within the section

export function getSectionHeadingId(widgetId, sectionId) {
  return `${widgetId}-${sectionId}-heading`;
} // Calculate the metrics for a line
// to determine its overall weight

export function calculateLineMetrics(data) {
  if (data.length === 0) return {
    weight: -Infinity
  }; // Calculate various metrics for the line

  const metrics = {
    max: Math.max(...data),
    min: Math.min(...data),
    last: data[data.length - 1],
    first: data[0],
    length: data.length,
    sum: data.reduce((acc, val) => acc + val, 0),
    mean: data.reduce((acc, val) => acc + val, 0) / data.length,
    // Average height of the line
    trend: 0,
    weight: 0
  }; // Measure the overall direction and rate of change
  // positive slope = ascending, negative = descending

  metrics.trend = data.length > 1 ? (data[data.length - 1] - data[0]) / (data.length - 1) : 0; // Calculate a weighted score for the line

  metrics.weight = metrics.mean * 0.35 + // Overall height
  metrics.last * 0.35 + // Recent values
  metrics.max * 0.2 + // Peak values
  metrics.trend * 0.1; // Direction

  return metrics;
} // Helper function to force chart re-renders on config changes

export function buildChartRenderingHash(options) {
  const hashArr = [];

  if (options.animation) {
    Object.entries(options.animation).forEach(_ref => {
      let [key, value] = _ref;
      return hashArr.push(`${key}:${value}`);
    });
  }

  if (options.themeStyles) {
    Object.entries(options.themeStyles).forEach(_ref2 => {
      let [key, value] = _ref2;
      return hashArr.push(`${key}:${value}`);
    });
  }

  return hashArr.join('.');
} // Get the chart annotation settings for the axes title positioned "over"

export const getChartTitleAnnotationSettings = options => {
  const positionOptions = options.axis === 'x' ? {
    position: {
      x: 'start',
      // Left align
      y: 'start' // Top align

    },

    xAdjust(ctx) {
      const xScale = ctx.chart.scales.y; // @ts-ignore

      return xScale.width * -1 + (options.xAdjust ?? 0);
    },

    xValue: function (context) {
      return context.chart.scales.x.min;
    },
    yValue: function (context) {
      var _context$chart$data;

      // Get the first category (highest on y-axis in horizontal bar chart)
      const labels = ((_context$chart$data = context.chart.data) === null || _context$chart$data === void 0 ? void 0 : _context$chart$data.labels) || [];
      return labels[0];
    },
    // Offset above the top of the chart
    yAdjust: context => {
      // Calculate distance to move annotation up above the chart
      if (context.chart.scales.y) {
        const firstTickHeight = context.chart.scales.y.getPixelForTick(0);
        const chartAreaTop = context.chart.chartArea.top; // Move up by the distance between the first tick and the top
        // plus a small margin, as a negative value

        return -(firstTickHeight - chartAreaTop + 40);
      }

      return -40; // Fallback if scales not available
    }
  } : {
    position: {
      x: 'start',
      // Left align
      y: 'start' // Top align

    },
    // Position at the first x label
    xValue: context => {
      const labels = context.chart.data.labels || [];
      if (labels.length > 0) return labels[0]; // Position at the first category

      return context.chart.scales.x.min;
    },
    // Position at the top of the chart
    yValue: context => {
      // Get the maximum value on the y-axis
      return context.chart.scales.y.max;
    },
    // Fine-tune the position
    xAdjust: context => {
      // Calculate distance to move annotation up above the chart
      if (context.chart.scales.x) {
        // Move left by the distance between the first tick and left edge
        const firstTickWidth = context.chart.scales.x.getPixelForTick(0);
        return -firstTickWidth;
      }

      return -40; // Fallback if scales not available
    },
    yAdjust: context => {
      if (context.chart.scales.y) {
        // Calculate space between top of chart area and top of scale
        const chartAreaTop = context.chart.chartArea.top; // Use a negative adjustment to move up

        return -(context.chart.scales.y.getPixelForValue(context.chart.scales.y.max) - chartAreaTop + 40);
      }

      return -30; // Fallback if scales not available
    }
  };
  return {
    clip: false,
    animation: {
      duration: 0
    },
    annotations: {
      scaleTitle: _objectSpread(_objectSpread(_objectSpread({
        type: 'label',
        drawTime: 'afterDraw',
        // Draw after chart is drawn
        padding: {
          bottom: 24
        },
        content: options.title
      }, options.axisFont), positionOptions), {}, {
        click: (_, event) => selectEditingArea({
          widgetId: options.widgetId,
          sectionId: options.sectionId,
          sectionEditingScope: 'chart-axes',
          sectionEditingArea: 'chart-axes',
          editingAreaMeta: JSON.stringify({
            axis: 'y'
          }),
          clickPosition: getClickPositionFromEvent(event.native)
        })
      })
    }
  };
}; // Get the styles for the chart grid
// based on the theme settings

export const getChartGridStyles = function (theme) {
  let reversed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let overrides = arguments.length > 2 ? arguments[2] : undefined;
  const gridSettings = mergeWith({}, getGridSettings(theme), overrides || {}, arrayOverwriteStrategy);
  const xAxisSettings = reversed ? gridSettings.gridSecondary : gridSettings.grid;
  const yAxisSettings = reversed ? gridSettings.grid : gridSettings.gridSecondary;
  return deleteUndefinedValues({
    // X axis
    xAxisGridVisible: xAxisSettings.visible,
    xAxisGridColor: xAxisSettings.color,
    xAxisGridBorderDash: xAxisSettings.borderDash,
    xAxisGridBorderWidth: xAxisSettings.borderWidth,
    // Y axis
    yAxisGridVisible: yAxisSettings === null || yAxisSettings === void 0 ? void 0 : yAxisSettings.visible,
    yAxisGridColor: yAxisSettings === null || yAxisSettings === void 0 ? void 0 : yAxisSettings.color,
    yAxisGridBorderDash: yAxisSettings === null || yAxisSettings === void 0 ? void 0 : yAxisSettings.borderDash,
    yAxisGridBorderWidth: yAxisSettings === null || yAxisSettings === void 0 ? void 0 : yAxisSettings.borderWidth
  });
};